import { SelectQueryBuilder } from 'kysely'
import { Database } from '../database'

export type PersonFilters = {
  isDeleted?: boolean
  email?: string
  createdBefore?: string
  createdAfter?: string
  updatedBefore?: string
  updatedAfter?: string
  deletedBefore?: string
  deletedAfter?: string
  search?: string
  hasApps?: boolean
  withoutApps?: boolean
  id?: string
  tags?: string[]
}

export function applyPersonFilters<T>(
  query: SelectQueryBuilder<Database, 'person', T>,
  filters: PersonFilters
): SelectQueryBuilder<Database, 'person', T> {
  if (filters.isDeleted !== true) {
    query = query.where('person.deleted', '=', filters.isDeleted ? 1 : 0)
  }
  if (filters.email) {
    query = query.where('person.email', 'like', `%${filters.email}%`)
  }
  if (filters.createdBefore) {
    query = query.where('person.created', '<', filters.createdBefore)
  }
  if (filters.createdAfter) {
    query = query.where('person.created', '>', filters.createdAfter)
  }
  if (filters.updatedBefore) {
    query = query.where('person.updated', '<', filters.updatedBefore)
  }
  if (filters.updatedAfter) {
    query = query.where('person.updated', '>', filters.updatedAfter)
  }
  if (filters.deletedBefore) {
    query = query.where('person.deleted_at', '<', filters.deletedBefore)
  }
  if (filters.deletedAfter) {
    query = query.where('person.deleted_at', '>', filters.deletedAfter)
  }
  if (filters.tags?.length) {
    query = query.where((eb) =>
      eb.and(
        (filters.tags ?? []).map((tag) => eb('person.tags', 'like', `%${tag}%`))
      )
    )
  }
  if (filters.hasApps) {
    query = query.where((eb) =>
      eb.exists(
        eb
          .selectFrom('licence_out')
          .select('licence_out.account_id')
          .whereRef('licence_out.account_id', '=', 'person._id')
          .limit(1)
      )
    )
  }
  if (filters.withoutApps) {
    query = query.where((eb) =>
      eb.not(
        eb.exists(
          eb
            .selectFrom('licence_out')
            .select('licence_out.account_id')
            .whereRef('licence_out.account_id', '=', 'person._id')
            .limit(1)
        )
      )
    )
  }
  if (filters.id) {
    query = query.where('person._id', '=', filters.id)
  }
  if (filters.search) {
    query = query.where((eb) =>
      eb.or([
        eb('person.name', 'like', `%${filters.search}%`),
        eb('person.email', 'like', `%${filters.search}%`),
      ])
    )
  }
  return query
}
